'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    if (window.fetch) {
        return Promise.resolve(window.fetch);
    }

    return (0, _loadScript2.default)('https://cdn.staticsfly.com/gbundles/cdn/whatwg-fetch-2.0.4.js').then(function () {
        return window.fetch;
    });
};

var _loadScript = require('./loadScript');

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//# sourceMappingURL=polyfillFetch.js.map